module.exports = __webpack_public_path__ + "img/info_1.5f0262ec.jpeg";